import { useEffect, useState } from "react";
import { useSearchParams, Link , useParams} from "react-router-dom";
import { Col, Row, Table, Button, Grid, Spin } from "antd";
import { PageName, SearchContainer, SearchIcon, SearchInput, SearchButton, StyledCard } from './style';
import { MyText } from "../../components";
import {LeftOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import { ButtonContainer } from "../MaterialsDetail/style";
import { MyButton } from "../../components";
import dayjs from "dayjs";
import { SurveyRow } from "./style";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import html2pdf from "html2pdf.js";
import { LogoIcon } from "../../assets";
import ReactDOM from "react-dom";
import { useEmbeddedNavigate } from "../../utils/context/embed";
import { useDispatch, useSelector } from "react-redux";
import { fetchExportResultsPDFAction, fetchTestResultsAction } from "../../utils";

const isMobile = window.innerWidth < 768;

export const ResultsPage = () => {
  const {t} = useTranslation("common")

  const [searchParams, setSearchParams] = useSearchParams();
  const [kindergartens, setKindergartens] = useState<any[]>([]);

  const [selectedSurvey, setSelectedSurvey] = useState(null);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const embeddedNavigate = useEmbeddedNavigate();
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const segmentedParams: any = searchParams.get('type');
  const {testId} = useParams();
  const {type} = useParams();
  const [loadingPDF, setLoadingPDF] = useState<{ [key: number]: boolean }>({});
  const exportResultsPDF = useSelector((state: any) => state.materials?.exportResultsPDF ?? { loading: false });
  const testResults = useSelector((state: any) => state.materials?.testResults ?? { data: null, loading: false });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getYearLabel = (age: any) => {
    const lastDigit = age % 10;
    const lastTwoDigits = age % 100;
  
    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return t("ages2");
    if (lastDigit === 1) return t("ages1");
    if (lastDigit >= 2 && lastDigit <= 4) return t("ages");
    return t("ages2");
  };

  
  // useEffect(() => {
  //       const fetchData = async () => {
  //         try {
  //           const response = await fetchTestResults(type, undefined, testId );
  //           if (response && response.results) {
  //             setKindergartens(response.results);
  //           //   const selectedSurveyItem = response.results
  //           // .find(item => item.test_id == testId)
  //           //   ?.surveys?.[0];

  //             const selectedSurveyItem = response.results.find(item => item.test_id == testId)?.type == 3 || response.results.find(item => item.test_id == testId)?.type == 4
  // ? response.results.find(item => item.test_id == testId)
  // : response.results.find(item => item.test_id == testId)?.surveys?.[0];
  //           console.log(selectedSurveyItem)
  //           if (selectedSurveyItem) {
  //             setSelectedSurvey(selectedSurveyItem);  
  //           }
  //           } else {
  //             setKindergartens([]);
  //           }
  //         } catch (error) {
  //           console.error("Ошибка при получении данных:", error);
  //         } finally {
  //           setLoading(false);
  //         }
  //       };
    
  //       fetchData();

  //     }, []);

      useEffect(() => {
        dispatch(fetchTestResultsAction({ type, user_test_id: testId }));
      }, []);

      useEffect(() => {
        if (!testResults.success || !testResults.data?.results) return;
        
        setKindergartens(testResults.data.results);
        setLoading(false);

        const found = testResults.data.results.find(item => item.test_id == testId);
        const selectedSurveyItem = found?.type == 3 || found?.type == 4
          ? found
          : found?.surveys?.[0];

        if (selectedSurveyItem) {
          setSelectedSurvey(selectedSurveyItem);
        }
      }, [testResults.success, testResults.data]);

      const handleGoBack = () => {
        const testType = kindergartens.find(item => item.test_id == testId)?.type;
        
        if (testType == 1) {
          embeddedNavigate(`/screening/tests-list`);
        } else if (testType == 2) {
          embeddedNavigate(`/screening/with_specialist`);
        } else if (testType == 3) {
          embeddedNavigate(`/screening/neuropsychology`);
        } else if (testType == 4) {
          embeddedNavigate(`/screening/readiness/tests-list`);
        }
      };

//   const handleOpenPDF = async () => {
//   try {
//     if (!testId) {
//       console.warn("testId не найден");
//       return;
//     }

//     setLoadingPDF(prev => ({ ...prev, [testId]: true }));

//     const pdfBlob = await fetchExportContentResults(testId);

//     const typeName =
//       testType == 2 ? t("screeningResult") :
//       testType == 1 ? t("selfdiagnosisResult") :
//       testType == 3 ? t("neuroResult") :
//       testType == 4 ? t("schoolReadinessResult") :
//       "";

//     const fileName = `${typeName} SabiDamu ${testId}.pdf`;

//     const url = window.URL.createObjectURL(pdfBlob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = fileName;
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//     window.URL.revokeObjectURL(url);

//   } catch (e) {
//     console.error("Ошибка PDF:", e);
//   } finally {
//     setLoadingPDF(prev => ({ ...prev, [testId]: false }));
//   }
// };

    const handleOpenPDF = () => {
      if (!testId) return;

      const typeName =
        testType == 2 ? t("screeningResult") :
        testType == 1 ? t("selfdiagnosisResult") :
        testType == 3 ? t("neuroResult") :
        testType == 4 ? t("schoolReadinessResult") : "";

      dispatch(fetchExportResultsPDFAction({ id: testId, typeName }));
    };

  const handleDownloadAll = async () => {
    const surveys = kindergartens.find(item => item.test_id == testId)?.surveys;
    
    if (surveys && surveys.length > 0) {
        const contentDiv = document.createElement("div");
        contentDiv.style.padding = "5px";
        contentDiv.style.fontFamily = "Nunito";
        contentDiv.style.fontSize = "16px";
        contentDiv.style.lineHeight = "24px";


        const logoContainer = document.createElement("div");
          logoContainer.style.display = "flex";
          logoContainer.style.marginBottom = "12px";
  
          ReactDOM.render(<LogoIcon style={{ width: 263, height: 52 }} />, logoContainer);
          const age = kindergartens.find(item => item.test_id == testId)?.age;
          const ageLabel = age
            ? Number(type) === 3 || Number(type) === 4
              ? `${Math.floor(age / 12)} ${getYearLabel(Math.floor(age / 12))}`
              : `${age} ${t("months")}`
            : '-';

        const newContentDiv = document.createElement("div");
        newContentDiv.innerHTML = `
          <div style="display: flex; justify-content: space-between; font-size: 16px; font-weight: 600; margin-bottom: 8px">
              <span><strong>${testType == 2 ? t("screeningResult") : testType == 1 ? t("selfdiagnosisResult") : testType == 3 ? t("neuroResult") : testType == 4 ? t("schoolReadinessResult") : ""} SabiDamu</strong></span>
              <span>${dayjs(kindergartens.find(item => item.test_id == testId)?.time_at).format('DD.MM.YYYY')}</span>
          </div>

          <div style="display: flex; align-items: center; font-size: 16px; font-weight: 600; margin-bottom: 25px">
            <span style="font-size: 24px; font-weight: 600" >${kindergartens.find(item => item.test_id == testId)?.name || "-"}</span>
            <span style="margin: 0 8px;">•</span>
            <span style="font-size: 24px; font-weight: 600">${ageLabel}</span>
        </div>
        `;
        contentDiv.appendChild(logoContainer);

        contentDiv.appendChild(newContentDiv);

        surveys.forEach(survey => {
          const nameDiv = document.createElement("div");
          nameDiv.style.fontSize = "24px";
          nameDiv.style.fontWeight = "800";
          nameDiv.style.marginBottom = "4px";
          nameDiv.innerHTML = survey.name || "";
      
          const recommendationDiv = document.createElement("div");
          recommendationDiv.style.fontSize = "16px";
          recommendationDiv.style.lineHeight = "32px";
          recommendationDiv.style.marginBottom = "16px";
          recommendationDiv.innerHTML = survey.recommendation || "";

          contentDiv.appendChild(nameDiv);
          contentDiv.appendChild(recommendationDiv);
      });

        html2pdf()
            .from(contentDiv)
            .set({
                margin: 16,
                filename: "document.pdf",
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
                // pagebreak: { mode: ["avoid-all", "css", "legacy"] }
                pagebreak: { mode: [ "css", "legacy"] }

            })
            .save();
    } else {
        console.warn("Нет доступных surveys для загрузки.");
    }
};

      const testType = kindergartens.find(item => item.test_id == testId)?.type;
      const age = kindergartens.find(item => item.test_id == testId)?.age;
          const ageLabel = age
            ? Number(type) === 3 || Number(type) === 4
              ? `${Math.floor(age / 12)} ${getYearLabel(Math.floor(age / 12))}`
              : `${age} ${t("months")}`
            : '-';

  return (
    <Row justify='center'>
      <Col span={20}>
          
          <Row align="middle" style={{marginBottom: 26, height:screens.xs ? 'auto' : '60px'}}>
          {screens.xs ? (
                                  <>
                                    <Col span={3}>
                                      <ButtonContainer onClick={handleGoBack}>
                                        <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                                      </ButtonContainer>
                                    </Col>
                                    <Col span={21}>
                                      <MyText
                                        color="rgba(19, 15, 38, 1)"
                                        size={26}
                                        weight={800}
                                        style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                                      >
                                        {testType == 2 ? t("screeningResult") : testType == 1 ? t("selfdiagnosisResult") : testType == 3 ? t("neuroResult") : testType == 4 ? t("schoolReadinessResult") : ""}
                                      </MyText>
                                    </Col>
                                  </>
                                ) : (
                                  <>
                                    <ButtonContainer onClick={handleGoBack}>
                                      <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                                    </ButtonContainer>
                                    <MyText
                                      color="rgba(19, 15, 38, 1)"
                                      size={32}
                                      weight={800}
                                      style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                                    >
                                      {testType == 2 ? t("screeningResult") : testType == 1 ? t("selfdiagnosisResult") : testType == 3 ? t("neuroResult") : testType == 4 ? t("schoolReadinessResult") : ""}
                                    </MyText>
                                  </>
                                )}
        </Row>

        <Row gutter={[24,24]}>
            
        {screens.xs && (
        <Col span={24}>
        <Row gutter={[0, 32]}>
        <Col span={24}>
          <StyledCard>
          <Row style={{ padding: 24 }} justify="center" align="middle">
            <Col span={24}>
                
            <Col span={24} >
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={18}
                    weight={600}
                    style={{ fontFamily: 'Nunito' }}
                  >
                    {testType == 2 ? t("screeningResult") : testType == 1 ? t("selfdiagnosisResult") : testType == 3 ? t("neuroResult") : testType == 4 ? t("schoolReadinessResult") : ""} SabiDamu
                  </MyText>
                </Col>
              <Col span={24} style={{marginTop: 8}}>
            <Row align="middle" gutter={8}>
              <Col>
                <MyText
                  color="rgb(58, 55, 74)"
                  size={18}
                  weight={500}
                  style={{ fontFamily: 'Nunito' }}
                >
                  {t("dateLabel")}
                </MyText>
              </Col>
              <Col>
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={18}
                  weight={600}
                  style={{ fontFamily: 'Nunito' }}
                >
                {dayjs(kindergartens.find(item => item.test_id == testId)?.time_at).format('DD.MM.YYYY')}
                </MyText>
              </Col>
            </Row>
          </Col>
              <Col span={24} style={{marginTop: 8}}>
            <Row align="middle" gutter={8}>
              <Col>
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={18}
                  weight={500}
                  style={{ fontFamily: 'Nunito' }}
                >
                  {t("childName")}:
                </MyText>
              </Col>
              <Col>
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={18}
                  weight={600}
                  style={{ fontFamily: 'Nunito' }}
                >
                  {kindergartens.find(item => item.test_id == testId)?.name || "-"}
                </MyText>
              </Col>
            </Row>
          </Col>
              <Col span={24} style={{marginTop: 8}}>
              <Row align="middle" gutter={8}>
                <Col>
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={18}
                  weight={500}
                  style={{ fontFamily: 'Nunito' }}
                >
                  {t("age")}:
                </MyText>
              </Col>
              <Col>
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={18}
                  weight={600}
                  style={{ fontFamily: 'Nunito' }}
                >
                  {ageLabel}
                </MyText>
              </Col>
              </Row>
              </Col>
              </Col>
              {testType === 1 && (
              <Col span={6}>
              <Row style={{background: 'rgba(244, 245, 247, 1)', borderRadius: 12, height: 64, width: 64, alignItems: 'center', justifyContent: 'center'}}>
                        <MyText color='rgba(19, 15, 38, 1)' weight={700} size={24}>{kindergartens.find(item => item.test_id == testId)?.surveys[0].score || "0"}</MyText>
                      </Row>
              </Col>
              )}
              </Row>
              
              
            </StyledCard>
          </Col>

          {type == '1' || type == '2' && (
        <Col span={24}>
            <StyledCard>
              <Row style={{ padding: 24, paddingBottom: 0 }}>
              <Col span={24}>
            <Row align="middle" gutter={8} >
              <Col>
                <MyText
                  color="rgba(19, 15, 38, 1)"
                  size={22}
                  weight={800}
                  style={{ fontFamily: 'Nunito' }}
                >
                  {t("routines")}
                </MyText>
              </Col>
            </Row>
            <Col span={24} style={{marginTop: 12}}>
            <Row gutter={24}>


            {kindergartens.find(item => item.test_id == testId)?.surveys?.map(item => (
                <Col span={24} key={item.id} onClick={() => setSelectedSurvey(item)}>
                <SurveyRow isSelected={selectedSurvey?.id === item.id}>
                  <MyText
                    color={selectedSurvey?.id === item.id ? 'rgba(205, 97, 21, 1)' : 'rgba(10, 3, 60, 1)'}
                    size={18}
                    weight={800}
                    style={{ fontFamily: 'Nunito' }}
                  >
                    {item.name}
                  </MyText>
                </SurveyRow>
              </Col>
              ))}
            </Row>
            </Col>
          </Col>
          
              </Row>
              <Row justify="center" style={{marginBottom: 16}}>
                <MyButton type="primary" onClick={handleDownloadAll}>
                  {t("downloadAll")}
                </MyButton>
              </Row>
            </StyledCard>
          </Col>
          )}
          </Row>
        </Col>
             )}


            <Col span={screens.xs ? 24 : 18}>
            <StyledCard>
              <Row style={{ padding: 32 }} align="middle" justify="space-between">
                <Col span={17}>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={20}
                    weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block', marginLeft:screens.xs ? 0 : 32 }}
                  >
                    {t("recommendation")}
                  </MyText>
                </Col>
                <Col span={screens.xs ? 24 : 4} style={{marginTop: screens.xs ? 16 : 0, marginBottom: screens.xs ? 16 : 0, borderRadius: 10, background:'rgba(231, 250, 255, 1)', border: 'none', cursor: 'pointer',}} onClick={() => handleOpenPDF()}>
                {/* <Button style={{borderRadius: 10, height: 38, background:'rgba(231, 250, 255, 1)', border: 'none'}} onClick={handleOpenPDF}> */}
                <Row align="middle" justify="center" style={{ height: 40 }}>
                  { exportResultsPDF.loading ? (
                      <Spin size="small" style={{ color: 'white' }} />
                    ) : (
                      <MyText
                        color="rgba(0, 141, 210, 1)"
                        weight={700}
                        style={{ fontFamily: 'Nunito' }}
                      >
                        {t("downloadResult")}
                      </MyText>
                    )}
                </Row>
                  {/* </Button> */}
                </Col>
                <Col style={{ maxWidth: '100%', wordWrap: 'break-word', padding: screens.xs ? 0 : 32 }}>
                  {selectedSurvey?.recommendation ? (
                    <MyText
                      color="rgba(19, 15, 38, 1)"
                      size={24}
                      weight={400}
                      style={{ fontFamily: 'Nunito', lineHeight: '32px', textAlign: screens.xs ? "left" : 'justify' }}
                    >
                      <div
                        id="export-content"
                        style={{
                          fontFamily: 'Nunito',
                          lineHeight: '16px',
                          fontSize: '16px',
                        }}
                        dangerouslySetInnerHTML={{
                          __html: selectedSurvey?.recommendation,
                        }}
                      />
                    </MyText>
                  ) : (
                    <MyText
                      color="rgba(19, 15, 38, 1)"
                      size={16}
                      weight={400}
                      style={{ fontFamily: 'Nunito', textAlign: 'center' }}
                    >
                      {t("noRecommendation")}
                    </MyText>
                  )}
                </Col>
                <Col span={24}>
                <Row align="middle" justify="center" style={{ marginTop: '38px', gap: '25px' }}>
                        
                        <MyButton
                          type="default"
                          style={{ padding: '28px 28px', background: 'rgba(229, 233, 242, 1)' }}
                          onClick={handleGoBack}
                        >
                          <MyText
                            weight={600}
                            size={18}
                            style={{ lineHeight: '24px' }}
                          >
                            {t("returnToList")}
                          </MyText>
                        </MyButton>
                      </Row>
                </Col>
              </Row>
            </StyledCard>
          </Col>
          
          {screens.xs ? null : (
          <Col span={6}>
          <Row gutter={[0, 32]}>
          <Col span={24}>
            <StyledCard>
            <Row style={{ padding: 24 }} justify="center" align="middle">
              {/* <Col span={testType === 2 ? 24 : 18}> */}

              <Col span={24}>
              <Col span={24} >
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={18}
                    weight={600}
                    style={{ fontFamily: 'Nunito' }}
                  >
                  {testType == 2 ? t("screeningResult") : testType == 1 ? t("selfdiagnosisResult") : testType == 3 ? t("neuroResult") : testType == 4 ? t("schoolReadinessResult") : ""} SabiDamu
                  </MyText>
                </Col>
                <Col span={24} style={{marginTop: 8}}>
              <Row align="middle" gutter={8}>
                <Col>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={18}
                    weight={500}
                    style={{ fontFamily: 'Nunito' }}
                  >
                    {t("dateLabel")}
                  </MyText>
                </Col>
                <Col>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={18}
                    weight={600}
                    style={{ fontFamily: 'Nunito' }}
                  >
                  {dayjs(kindergartens.find(item => item.test_id == testId)?.time_at).format('DD.MM.YYYY')}
                  </MyText>
                </Col>
              </Row>
            </Col>
                <Col span={24} style={{marginTop: 8}}>
              <Row align="middle" gutter={8}>
                <Col>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={18}
                    weight={500}
                    style={{ fontFamily: 'Nunito' }}
                  >
                    {t("childName")}:
                  </MyText>
                </Col>
                <Col>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={18}
                    weight={600}
                    style={{ fontFamily: 'Nunito' }}
                  >
                    {kindergartens.find(item => item.test_id == testId)?.name || "-"}
                  </MyText>
                </Col>
              </Row>
            </Col>
                <Col span={24} style={{marginTop: 8}}>
                <Row align="middle" gutter={8}>
                  <Col>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={18}
                    weight={500}
                    style={{ fontFamily: 'Nunito' }}
                  >
                    {t("age")}:
                  </MyText>
                </Col>
                <Col>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={18}
                    weight={600}
                    style={{ fontFamily: 'Nunito' }}
                  >
                    {ageLabel}
                  </MyText>
                </Col>
                </Row>
                </Col>
                </Col>
                {testType === 1 && (
                <Col span={6}>
                <Row style={{background: 'rgba(244, 245, 247, 1)', borderRadius: 12, height: 64, width: 64, alignItems: 'center', justifyContent: 'center'}}>
                          <MyText color='rgba(19, 15, 38, 1)' weight={700} size={24}>{kindergartens.find(item => item.test_id == testId)?.surveys[0].score || "0"}</MyText>
                        </Row>
                </Col>
                )}
                </Row>
                
                
              </StyledCard>
            </Col>

          {type == '1' || type == '2' && (
          <Col span={24}>
              <StyledCard>
                <Row style={{ padding: 24, paddingBottom: 0 }}>
                <Col span={24}>
              <Row align="middle" gutter={8} >
                <Col>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={22}
                    weight={800}
                    style={{ fontFamily: 'Nunito' }}
                  >
                    {t("routines")}
                  </MyText>
                </Col>
              </Row>
              <Col span={24} style={{marginTop: 12}}>
              <Row gutter={24}>

              {kindergartens.find(item => item.test_id == testId)?.surveys?.map(item => (
                  <Col span={24} key={item.id} onClick={() => setSelectedSurvey(item)}>
                  <SurveyRow isSelected={selectedSurvey?.id === item.id}>
                    <MyText
                      color={selectedSurvey?.id === item.id ? 'rgba(205, 97, 21, 1)' : 'rgba(10, 3, 60, 1)'}
                      size={18}
                      weight={800}
                      style={{ fontFamily: 'Nunito' }}
                    >
                      {item.name}
                    </MyText>
                  </SurveyRow>
                </Col>
                ))}
              </Row>
              </Col>
            </Col>
            
                </Row>
                <Row justify="center" style={{marginBottom: 16}}>
                  <MyButton type="primary" onClick={handleDownloadAll}>
                    {t("downloadAll")}
                  </MyButton>
                </Row>
              </StyledCard>
            </Col>
            )}
            </Row>
          </Col>
          
          )}</Row>
      </Col>
    </Row>
  );
};
